import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { extractGlobalStoreLoggingData } from '@/lib/utils/logging/extractGlobalStoreLoggingData'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { HydraErrorType } from '../_hydraError.d'
import type { HydraPostOrderProps, HydraPostOrderResponse } from './postOrder'

export const buildHeaders = ({ locale }: { locale: SupportedLocale }) => ({
  'Accept-Language': locale,
})

type HydraPostUnifiedOrderResponse = {
  status: string
  data: {
    order: HydraPostOrderResponse
    autoOrder: HydraPostOrderResponse
  }
}

export const HydraPostUnifiedOrder = async ({
  locale,
  order,
  token,
  timeout,
  returnStructuredErrors,
  globalStore,
  loggingParameters,
}: HydraPostOrderProps) => {
  const headers = buildHeaders({ locale })
  const withAuth = !!token

  const globalStoreLoggingData = globalStore
    ? extractGlobalStoreLoggingData(globalStore)
    : {}

  const request: SendRequestType = {
    method: 'POST',
    withAuth,
    token,
    headers,
    data: order,
    url: `/customers/me/ordersAndSubscriptions?async=false`,
    timeout,
    returnStructuredErrors,
    loggingEnabled: true,
    loggingParameters: {
      ...loggingParameters,
      ...globalStoreLoggingData,
    },
  }

  return httpTools.sendRequest<HydraPostUnifiedOrderResponse & HydraErrorType>(
    request,
  )
}
